var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        _vm._l(_vm.groups, function(group) {
          return _c(
            "el-tab-pane",
            { attrs: { label: group.name, name: group.name } },
            [
              _c(
                "el-checkbox-group",
                {
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.checkedRescIds,
                    callback: function($$v) {
                      _vm.checkedRescIds = $$v
                    },
                    expression: "checkedRescIds"
                  }
                },
                _vm._l(group.sysRescs, function(appResc) {
                  return _c("div", [
                    _c("div", { staticClass: "content-caption dashed" }, [
                      _c(
                        "label",
                        {
                          on: {
                            change: function($event) {
                              _vm.handleCheckAllChange(appResc)
                            }
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            { attrs: { disabled: "", label: appResc.rescId } },
                            [
                              _c("span", { staticClass: "'font-gray2 mr5'" }, [
                                _vm._v(_vm._s(appResc.rescName))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("（"),
                                _c("span", { staticClass: "font-gray3" }, [
                                  _vm._v(_vm._s(appResc.rescDesc))
                                ]),
                                _vm._v("）")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "switch-list clearfix ml15" },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            attrs: { disabled: "" },
                            model: {
                              value: appResc.checkedActions,
                              callback: function($$v) {
                                _vm.$set(appResc, "checkedActions", $$v)
                              },
                              expression: "appResc.checkedActions"
                            }
                          },
                          _vm._l(appResc.actionList, function(action) {
                            return _c(
                              "div",
                              {
                                staticClass: "switch-item ellipsis-1",
                                staticStyle: {
                                  width: "auto",
                                  "margin-right": "30px"
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { disabled: "", label: action.code }
                                  },
                                  [_c("span", [_vm._v(_vm._s(action.name))])]
                                )
                              ],
                              1
                            )
                          })
                        )
                      ],
                      1
                    )
                  ])
                })
              )
            ],
            1
          )
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35029ada", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35029ada","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/comn/TplComRoleRescForMobApp.vue
// module id = 3482
// module chunks = 0